import React from 'react';

import PropTypes from 'prop-types';
import Image from '../../../atoms/image/Image';
import { getOccupancyLabel } from '../../../../../utils/Room';
import PriceInline from '../../../molecules/price';

const getCurrency = (currency, roundAmount) => {
  if (roundAmount) {
    return {
      ...currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    };
  }
  return currency;
};

const MBExtra = ({
  room, roomIndex,
}, context) => {
  const guests = getOccupancyLabel(room.occupancy, context);
  return (
          <div>
            <h3 className={'flex justify-between w-full uppercase leading-tight text-lg'}>
              <span className="font-bold">{context.t('ENHANCE YOUR STAY ITEMS')}:</span>
              {roomIndex && <span className="text-gray-600">Room {roomIndex}</span>}
            </h3>
            <div className="flex justify-between mb-2">
              {guests && <span className="ml-auto text-gray-600">{guests}</span>}
            </div>
            <div className="flex flex-wrap">
              {room.extras.map((extra, index) => (
                      <div key={index} className={'flex-row flex-wrap flex-grow m-4'}>
                        <div className={'flex flex-col sm:grid sm:grid-cols-3 gap-1'}>
                          <div className={'col-span-2 flex-grow-default flex'}>
                            <div className={'flex flex-col sm:grid sm:grid-cols-2 gap-1'}>
                              <div className={'flex-auto w-full sm:w-32'}>
                                <Image img={extra.photos.length > 0
                                && extra.photos[0].url
                                  ? extra.photos[0].url : ''} alt={extra.name}/>
                              </div>
                              <div className={'flex-auto w-full sm:w-64'}>
                                <header className="text-base uppercase text-primary font-bold">
                                  {extra.title}
                                </header>
                                <span className={'text-justify'}>{extra.name}</span>
                              </div>
                            </div>
                          </div>
                          <div className={'md:pl-6 md:mt-0 md:ml-auto self-end text-xl flex-grow-default flex'}>
                            <div className={'mb-2 my-4 ml-auto px-4 md:my-0'}>
                              <PriceInline
                                      amount={extra.amount}
                                      currency={getCurrency(room.currency, true)}
                                      nights={1}
                                      className="text-gray-700 py-2 text-lg"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
              ))}
            </div>
          </div>);
};

MBExtra.contextTypes = {
  t: PropTypes.func.isRequired,
};
MBExtra.propTypes = {
  roomIndex: PropTypes.number,
  room: PropTypes.object.isRequired,
};
export default MBExtra;
